
            import { Injectable } from '@angular/core';
            import { RockService } from '../rock.service';
            import { MicrosoftDataEdmAnnotationsIEdmDirectValueAnnotationsManager, MicrosoftDataEdmAnnotationsIEdmVocabularyAnnotation, MicrosoftDataEdmIEdmModel, MicrosoftDataEdmIEdmSchemaElement, MicrosoftDataEdmIEdmTerm, MicrosoftDataEdmIEdmType, MicrosoftDataEdmIEdmTypeReference, MicrosoftDataEdmIEdmVocabularyAnnotatable, MicrosoftDataODataQuerySemanticAstFilterClause, MicrosoftDataODataQuerySemanticAstOrderByClause, MicrosoftDataODataQuerySemanticAstRangeVariable, MicrosoftDataODataQuerySemanticAstSelectExpandClause, MicrosoftDataODataQuerySemanticAstSelectItem, MicrosoftDataODataQuerySemanticAstSingleValueNode, RockFieldConfigurationValue, RockModelAttribute, RockModelAttributeQualifier, RockModelBinaryFile, RockModelBinaryFileType, RockModelBlock, RockModelBlockType, RockModelCampus, RockModelCampusSchedule, RockModelCampusTopic, RockModelCategory, RockModelDataView, RockModelDataViewFilter, RockModelDefinedValue, RockModelDevice, RockModelDocument, RockModelDocumentType, RockModelEntityType, RockModelFieldType, RockModelGroup, RockModelGroupLocation, RockModelGroupLocationScheduleConfig, RockModelGroupMember, RockModelGroupMemberAssignment, RockModelGroupMemberRequirement, RockModelGroupMemberScheduleTemplate, RockModelGroupRequirement, RockModelGroupRequirementType, RockModelGroupSync, RockModelGroupType, RockModelGroupTypeLocationType, RockModelGroupTypeRole, RockModelLayout, RockModelLocation, RockModelMapCoordinate, RockModelMapItem, RockModelPage, RockModelPageContext, RockModelPageRoute, RockModelPerson, RockModelPersonAlias, RockModelPhoneNumber, RockModelSchedule, RockModelSignatureDocumentTemplate, RockModelSite, RockModelSiteDomain, RockModelSystemCommunication, RockModelSystemPhoneNumber, RockModelUserLogin, RockModelWorkflowActionForm, RockModelWorkflowActionFormAttribute, RockModelWorkflowActionFormSection, RockModelWorkflowActionType, RockModelWorkflowActivityType, RockModelWorkflowFormBuilderTemplate, RockModelWorkflowType, RockRestControllersGroupsControllerFamilySearchResult, RockRestControllersGroupsControllerGuestFamily, RockRestControllersGroupsControllerGuestFamilyMember, RockRestControllersGroupsControllerInfoWindowRequest, RockRestControllersGroupsControllerInfoWindowResult, RockWebCacheAttributeCache, RockWebCacheAttributeValueCache, RockWebUIControlsTreeViewItem, SystemDataEntitySpatialDbGeography, SystemDataEntitySpatialDbGeographyWellKnownValue, SystemWebHttpODataODataQueryContext, SystemWebHttpODataQueryFilterQueryOption, SystemWebHttpODataQueryInlineCountQueryOption, SystemWebHttpODataQueryODataQueryOptionsRockModelGroup, SystemWebHttpODataQueryODataRawQueryOptions, SystemWebHttpODataQueryOrderByNode, SystemWebHttpODataQueryOrderByQueryOption, SystemWebHttpODataQuerySelectExpandQueryOption, SystemWebHttpODataQuerySkipQueryOption, SystemWebHttpODataQueryTopQueryOption, SystemWebHttpODataQueryValidatorsFilterQueryValidator, SystemWebHttpODataQueryValidatorsODataQueryValidator, SystemWebHttpODataQueryValidatorsOrderByQueryValidator, SystemWebHttpODataQueryValidatorsSelectExpandQueryValidator, SystemWebHttpODataQueryValidatorsSkipQueryValidator, SystemWebHttpODataQueryValidatorsTopQueryValidator} from './Groups.models';

            @Injectable()
            export class GroupsService extends RockService {
            
                override entityType = 'Groups';
            
                    /**
                     * Queryable GET endpoint
                     */
                    GetGroups() {
                        return this.get(`Groups`);
                    }

                    /**
                     * POST endpoint. Use this to add a record
                     */
                    PostGroups(value: RockModelGroup) {
                        return this.post(`Groups`, value);
                    }

                    /**
                     * GET endpoint to get a single record
                     */
                    GetGroupsByid(id: number) {
                        return this.get(`Groups/${id}`);
                    }

                    /**
                     * PUT endpoint. Use this to update a record
                     */
                    PutGroupsByid(id: number, value: RockModelGroup) {
                        return this.put(`Groups/${id}`, value);
                    }

                    /**
                     * DELETE endpoint. To delete the record
                     */
                    DeleteGroupsByid(id: number) {
                        return this.delete(`Groups/${id}`);
                    }

                    /**
                     * PATCH endpoint. Use this to update a subset of the properties of the record
                     */
                    PatchGroupsByid(id: number, values: object) {
                        return this.patch(`Groups/${id}`, values);
                    }

                    /**
                     * POST an attribute value. Use this to set an attribute value for the record
                     */
                    PostGroupsAttributeValueByid(id: number) {
                        return this.post(`Groups/AttributeValue/${id}`);
                    }

                    /**
                     * DELETE to delete the specified attribute value for the record
                     */
                    DeleteGroupsAttributeValueByid(id: number) {
                        return this.delete(`Groups/AttributeValue/${id}`);
                    }

                    /**
                     * Gets a list of groups surrounding the specified lat/long, optionally limited to the specified geofenceGroupTypeId
If geofenceGroupTypeId is specified, the list of GeoFence groups will be returned with the groups as child groups of that geofence group.
                     */
                    GetGroupsByLatLong() {
                        return this.get(`Groups/ByLatLong`);
                    }

                    /**
                     * Gets a list of groups surrounding the specified the location, optionally limited to the specified geofenceGroupTypeId
If geofenceGroupTypeId is specified, the list of GeoFence groups will be returned with the groups as child groups of that geofence group.
                     */
                    GetGroupsByLocation() {
                        return this.get(`Groups/ByLocation`);
                    }

                    /**
                     * Gets a list of objects represented by the selected data view
                     */
                    GetGroupsDataViewByid(id: number) {
                        return this.get(`Groups/DataView/${id}`);
                    }

                    /**
                     * undefined
                     */
                    GetGroupsFollowedItems() {
                        return this.get(`Groups/FollowedItems`);
                    }

                    /**
                     * undefined
                     */
                    GetGroupsGetByAttributeValue() {
                        return this.get(`Groups/GetByAttributeValue`);
                    }

                    /**
                     * Gets the children.
                     */
                    GetGroupsGetChildrenByid(id: number) {
                        return this.get(`Groups/GetChildren/${id}`);
                    }

                    /**
                     * Gets the families sorted by the person's GroupOrder (GroupMember.GroupOrder)
                     */
                    GetGroupsGetFamiliesBypersonId(personId: number) {
                        return this.get(`Groups/GetFamilies/${personId}`);
                    }

                    /**
                     * Gets the families by name search.
                     */
                    GetGroupsGetFamiliesByPersonNameSearchBysearchString(searchString: string) {
                        return this.get(`Groups/GetFamiliesByPersonNameSearch/${searchString}`);
                    }

                    /**
                     * Gets the families by name search.
                     */
                    GetGroupsGetFamiliesByPersonNameSearchBysearchStringBymaxResults(searchString: string, maxResults: number) {
                        return this.get(`Groups/GetFamiliesByPersonNameSearch/${searchString}/${maxResults}`);
                    }

                    /**
                     * Gets the family.
                     */
                    GetGroupsGetFamilyByfamilyId(familyId: number) {
                        return this.get(`Groups/GetFamily/${familyId}`);
                    }

                    /**
                     * Gets the guests (known relationship of can check-in) for given family.
                     */
                    GetGroupsGetGuestsForFamilyBygroupId(groupId: number) {
                        return this.get(`Groups/GetGuestsForFamily/${groupId}`);
                    }

                    /**
                     * Gets the map information.
                     */
                    GetGroupsGetMapInfoBygroupId(groupId: number) {
                        return this.get(`Groups/GetMapInfo/${groupId}`);
                    }

                    /**
                     * Gets the child map information.
                     */
                    GetGroupsGetMapInfoBygroupIdChildren(groupId: number) {
                        return this.get(`Groups/GetMapInfo/${groupId}/Children`);
                    }

                    /**
                     * Gets the families map information.
                     */
                    GetGroupsGetMapInfoBygroupIdFamiliesBystatusId(groupId: number, statusId: number) {
                        return this.get(`Groups/GetMapInfo/${groupId}/Families/${statusId}`);
                    }

                    /**
                     * Gets the member map information.
                     */
                    GetGroupsGetMapInfoBygroupIdMembersBygroupMemberStatus(groupId: number, groupMemberStatus: string) {
                        return this.get(`Groups/GetMapInfo/${groupId}/Members/${groupMemberStatus}`);
                    }

                    /**
                     * Gets the map information window.
                     */
                    PostGroupsGetMapInfoWindowBygroupIdBylocationId(groupId: number, locationId: number, infoWindowDetails: RockRestControllersGroupsControllerInfoWindowRequest) {
                        return this.post(`Groups/GetMapInfoWindow/${groupId}/${locationId}`, infoWindowDetails);
                    }

                    /**
                     * Returns a simplified data structure of the check-in parameters. This is used by FrontPorch but is generalized.
The children of the provided group GUID are incuded in the results.
                     */
                    GetGroupsGroupTypeCheckinConfigurationBygroupTypeGuid(groupTypeGuid: string) {
                        return this.get(`Groups/GroupTypeCheckinConfiguration/${groupTypeGuid}`);
                    }

                    /**
                     * Determines if the entity id is in the data view
                     */
                    GetGroupsInDataViewBydataViewIdByentityId(dataViewId: number, entityId: number) {
                        return this.get(`Groups/InDataView/${dataViewId}/${entityId}`);
                    }

                    /**
                     * Launches a workflow. And optionally passes the entity with selected id as the entity for the workflow
                     */
                    PostGroupsLaunchWorkflowByid(id: number, workflowAttributeValues: object) {
                        return this.post(`Groups/LaunchWorkflow/${id}`, workflowAttributeValues);
                    }

                    /**
                     * Saves a group address.
                     */
                    PutGroupsSaveAddressBygroupIdBylocationTypeId(groupId: number, locationTypeId: number) {
                        return this.put(`Groups/SaveAddress/${groupId}/${locationTypeId}`);
                    }

                    /**
                     * Sets the Context Cookie to the specified record. Use this to set the Campus Context, Group Context, etc
                     */
                    PutGroupsSetContextByid(id: number) {
                        return this.put(`Groups/SetContext/${id}`);
                    }

                    /**
                     * Sets the Context Cookie to the specified record. Use this to set the Campus Context, Group Context, etc
                     */
                    OptionsGroupsSetContextByid(id: number) {
                        return this.options(`Groups/SetContext/${id}`);
                    }

}